export default __webpack_public_path__ + "static/brand-video@3x-0c8758b2180421c370e58f1f269cd3c6.png";